import Plot from "react-plotly.js";
import { Layout } from "plotly.js";
import * as d3 from "d3";
import "plotly.js/dist/plotly-locale-de"
import React from "react";
import { getColor } from "../../helpers/locationColors";
import { RxWithTherapistsDto } from "../../../../api-client/api";
import { handleRxPlotClick } from "../../helpers/handlePlotClick";
import useStore from "../../../../helpers/useStore";
import { PatientsContext } from "../../../../stores/Patients/patients.provider";


interface ViolinPlotProps {
    countData: RxWithTherapistsDto[];
}

const RxTherapistCountsPlot: React.FC<ViolinPlotProps> = ({countData}) => {
    const patientsStore = useStore(PatientsContext);
    const groupedData = Object.groupBy(countData, ({ locationId }) => locationId);
    
    const traces: Partial<Plotly.ViolinData>[] = [];
    // const numLocations = Object.keys(groupedData).length;
    // const colorPalette = d3.scaleOrdinal(d3['schemeTableau10']).range().slice(0, numLocations);

    Object.keys(groupedData).map((locationId, index) => {
        const color = getColor(locationId);
        const group = groupedData[locationId];
        const trace: Partial<Plotly.ViolinData> = {
            x: group?.map(entry => entry.locationId),
            y: group?.map(entry => entry.therapistCount),
            type: "violin",
            points: "all",
            pointpos: 0,
            jitter: 0.5,
            // spanmode: "hard",
            box: {
                visible: true
            },
            meanline: {
                visible: true
            },
            line: { 
                color: color,
                width: 1,
            },
            hoveron: "points",
            hovertemplate: '%{text}',
            text: group?.map(entry => 
                `<b>Rx:</b> ${entry.rxNumber}<br><b>Behandlungsanzahl:</b> ${entry.therapyRxAmounts.map(tra => `${tra.amount}`).join(", ")}<br><b>Patient:</b> ${entry.patient.firstName} ${entry.patient.lastName}<br><b>Therapeuten:</b> ${entry.therapists.map(th => th.nickname).join(", ")}<br>`
            ),
            name: "",
            scalegroup: locationId,
        };

        traces.push(trace);
    });

    const layout: Partial<Layout> = {
        height: 400,
        autosize: true,
        xaxis: {
            tickfont: {
                family: 'Roboto', 
                size: 12,
            },
            zerolinecolor: 'rgb(204, 204, 204)',
            linecolor: 'rgb(204, 204, 204)',
        },
        yaxis: {
            title: {
                text: 'Anzahl',
                font: {
                    family: 'Roboto', 
                    size: 14,
                },
                standoff: 0,
            },
            tickfont: {
                family: 'Roboto', 
                size: 12,
            },
            griddash: 'dot',
            zeroline: true,
            zerolinecolor: 'rgb(204, 204, 204)',
            linecolor: 'rgb(204, 204, 204)',
            gridcolor: 'rgb(204, 204, 204)',
        },
        hoverlabel: {
            font: {
                family: 'Roboto',
                size: 12,
            }
        },
        showlegend: false,
        margin: {
            t: 40, 
            b: 50, 
            l: 50, 
            r: 35, 
        },
        modebar: {
            orientation: 'v'
        }
    };

    return (
        <Plot 
            data={traces} 
            layout={layout} 
            config={{ locale: 'de' }} 
            onClick={(data) => handleRxPlotClick(data, countData, patientsStore)}
            useResizeHandler={true} 
            style={{ width: "100%", height: "100%"}} 
        />
    );
}

export default RxTherapistCountsPlot;